import { Divider } from "antd";

interface SectionHeaderProps {
  type?: "primary" | "secondary";
  title: string;
  text?: string;
}

export default function SectionHeader({ type = "primary", title }: SectionHeaderProps) {
  if (type === "secondary") {
    return (
      <Divider variant="dotted" style={{ borderColor: "#779ecb" }}>
        {title}
      </Divider>
    );
  }

  return (
    <Divider style={{ borderColor: "#779ecb" }}>
      <h1>
        <strong>{title}</strong>
      </h1>
    </Divider>
  );
}
